import { Analytics } from '@cobliteam/analytics';
import { isWebDataError, isWebDataFetching, isWebDataSuccess } from '@cobliteam/api-lib';
import { Location } from '@cobliteam/common-types';
import { forgetPasswordRequest, selectForgetPasswordWebData } from '@cobliteam/store';
import { Button, Typography } from '@cobliteam/ui/components';
import Input from '@cobliteam/ui/form/Input';
import Icon from '@cobliteam/ui/icons';
import type React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const PasswordRecovery = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const forgetPasswordWebData = useSelector(selectForgetPasswordWebData);

  const [recoveryEmail, setRecoveryEmail] = useState('');

  const handleChangeRecoveryEmail = (event: React.ChangeEvent<HTMLInputElement>) => setRecoveryEmail(event.target.value);

  const handlePasswordRecovery = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (recoveryEmail) {
      Analytics.track('Login Password Recovery Button Clicked');
      dispatch(forgetPasswordRequest(recoveryEmail));
    }
  };

  useEffect(() => {
    if (isWebDataSuccess(forgetPasswordWebData)) {
      history.push(Location.TOKEN_VALIDATION);
    }
  }, [forgetPasswordWebData, history]);

  return (
    <>
      <Typography variant='text-lg-semibold' color='white'>
        Esqueceu a senha?
      </Typography>

      <Typography variant='body' className='mt-4 text-balanced text-white'>
        Insira abaixo seu e-mail cadastrado, iremos lhe enviar um código de segurança para que você possa cadastrar uma nova senha.
      </Typography>

      <form className='mt-8 flex flex-col' onSubmit={handlePasswordRecovery}>
        <div className='flex flex-col gap-1'>
          <Typography as={'label'} htmlFor='email' variant='text-md' color='white'>
            E-mail
          </Typography>
          <Input id='email' value={recoveryEmail} onChange={handleChangeRecoveryEmail} error={isWebDataError(forgetPasswordWebData)} placeholder='Insira seu e-mail cadastrado' />
          {isWebDataError(forgetPasswordWebData) && (
            <Typography variant='text-sm' color='danger'>
              Insira um e-mail válido
            </Typography>
          )}
          <Button className='w-fit self-end p-0 text-white' size='sm' variant='ghost' onClick={() => history.push(Location.TOKEN_VALIDATION)} startIcon={<Icon name='key-round' />}>
            Já possuo um código de segurança
          </Button>
        </div>

        <Button className='mt-9' type='submit' name='email' disabled={!recoveryEmail} loading={isWebDataFetching(forgetPasswordWebData)}>
          Enviar
        </Button>
      </form>
    </>
  );
};

export default PasswordRecovery;
